<div class="ad-container" *ngIf="!isLoadingLabels">
	<div class="header-wrap">
		<span class="tab" [ngClass]="{ selected: selectedTab === 'import' }" (click)="selectedTab = 'import'">{{
			labels.lbl_objetos_serao_importados
		}}</span>
		<span class="tab" [ngClass]="{ selected: selectedTab === 'interval' }" (click)="selectedTab = 'interval'">{{
			labels.lbl_geral_intervalo_coleta
		}}</span>
	</div>
	<div class="body-wrap">
		<ng-container *ngIf="!isLoadindAdData">
			<ng-container *ngIf="selectedTab === 'import'">
				<cpi-checkbox
					[value]="adFormData.toImport.users"
					(oValue)="adFormData.toImport.users = $event"
					[innerText]="labels.lbl_geral_usuarios"></cpi-checkbox>
				<cpi-checkbox
					[value]="adFormData.toImport.equipments"
					(oValue)="adFormData.toImport.equipments = $event"
					[innerText]="labels.lbl_geral_equipamentos"></cpi-checkbox>
				<cpi-checkbox
					[value]="adFormData.toImport.groups"
					(oValue)="adFormData.toImport.groups = $event"
					[innerText]="labels.lbl_grupos"></cpi-checkbox>
			</ng-container>

			<ng-container *ngIf="selectedTab === 'interval'">
				<div class="button-container">
					<cpi-checkbox
						[shared]="adFormData.interval"
						[value]="'daily'"
						(oValue)="adFormData.interval = $event"
						[hideUncheck]="true"
						[innerText]="labels.lbl_geral_diario"></cpi-checkbox>
					<cpi-checkbox
						[shared]="adFormData.interval"
						[value]="'weekly'"
						(oValue)="adFormData.interval = $event"
						[hideUncheck]="true"
						[innerText]="labels.lbl_geral_semanal"></cpi-checkbox>
				</div>
				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_horario_inicial }}</span>
					<select (change)="handleStartAt($event.target.value)">
						<option
							[value]="index + 1"
							[selected]="adFormData.formatedStartAt === handleStartAt(index + 1, true)"
							*ngFor="let time of [].constructor(23); let index = index">
							{{ index + 1 < 10 ? '0' : '' }}{{ index + 1 }}:00
						</option>
					</select>
				</div>

				<div class="dotted-input-container" *ngIf="adFormData.interval === 'weekly'">
					<span>{{ labels.lbl_geral_dia_da_semana }}</span>
					<select (change)="adFormData.weekDay = $event.target.value">
						<option [value]="'monday'" [selected]="adFormData.weekDay === 'monday'">{{ labels.lbl_geral_segunda }}</option>
						<option [value]="'tuesday'" [selected]="adFormData.weekDay === 'tuesday'">{{ labels.lbl_geral_terca }}</option>
						<option [value]="'wednesday'" [selected]="adFormData.weekDay === 'wednesday'">{{ labels.lbl_geral_quarta }}</option>
						<option [value]="'thursday'" [selected]="adFormData.weekDay === 'thursday'">{{ labels.lbl_geral_quinta }}</option>
						<option [value]="'friday'" [selected]="adFormData.weekDay === 'friday'">{{ labels.lbl_geral_sexta }}</option>
						<option [value]="'saturday'" [selected]="adFormData.weekDay === 'saturday'">{{ labels.lbl_geral_sabado }}</option>
						<option [value]="'sunday'" [selected]="adFormData.weekDay === 'sunday'">{{ labels.lbl_geral_domingo }}</option>
					</select>
				</div>
			</ng-container>

			<div class="button-container">
				<div class="button" [ngClass]="{ disabled: isUpdatingAdFormData || assyncCount.length > 0 }" (click)="updateAdConfig()">
					<span>{{ labels.lbl_geral_salvar }}</span>
					<span
						><cpi-dot-bounce-loading-effect
							[color]="'var(--const-white)'"
							*ngIf="isUpdatingAdFormData"></cpi-dot-bounce-loading-effect
					></span>
				</div>
			</div>
			<div class="button-container">
				<div
					class="button"
					[ngClass]="{ disabled: isUpdatingAdFormData || assyncCount.length > 0 }"
					(click)="executeAdExtraction()">
					<span>{{ labels.lbl_security_executar_agora }}</span>
					<span
						><cpi-dot-bounce-loading-effect
							[color]="'var(--const-white)'"
							*ngIf="assyncCount.length > 0"></cpi-dot-bounce-loading-effect
					></span>
				</div>
			</div>
		</ng-container>

		<cpi-dot-bounce-loading-effect *ngIf="isLoadindAdData" [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
	</div>
</div>

<cpi-dot-bounce-loading-effect *ngIf="isLoadingLabels" [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
